import React from "react";

import useMetricsLinkData from "src/organization/pages/project/environment/metrics/hooks/useMetricsLinkData";

import ServiceMetrics from "./ServiceMetrics";

export interface ServiceMetricsWrapperProps {
  name: string;
}

const ServiceMetricsWrapper = ({ name }: ServiceMetricsWrapperProps) => {
  const { deploymentType, type } = useMetricsLinkData();
  // deployment type exposed on Git15; fallback to #metrics link type for previous versions of Git
  const mappedType = deploymentType ?? type;

  return mappedType ? <ServiceMetrics name={name} /> : null;
};

export default ServiceMetricsWrapper;
